export default class OfferSidebarService {
  constructor($http) {
    this.$http = $http;
  }

  get_sidebar_data(offer_id, group) {
    return this.$http.get(
      '/admin/marketplace/offers/get_sidebar_data',
			{params: {offer_id: offer_id, group: group}}
		);
  }
}

OfferSidebarService.$inject = ['$http'];



// WEBPACK FOOTER //
// ./front/js/admin/services/offer-sidebar.service.js